import { Condition } from '../@types/Condition';

export const translateCondition = {
  [Condition.VeryGood]: 'Mycket bra skick',
  [Condition.Good]: 'Bra skick',
  [Condition.Ok]: 'Helt okej skick',
};
